var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"logout-modal"}},[_c('img',{attrs:{"src":"/img/btns/loading.svg","width":"200","height":"200","alt":"","title":""}})])}]

export { render, staticRenderFns }